<div class="assetDashboard" [class.assetDashboard--open]="isOpen">
  <div class="assetDashboard__content">
  @if (dashlets.length > 0 && defaultWorkspaces) {
    <gridster
      class="dashboard__content"
      [options]="gridsterOptions"
      >
      @for (dashlet of dashlets; track dashlet) {
        <gridster-item
          [item]="dashlet"
          [ngClass]="dashlet.name"
          class="dashboard__gridster-item"
          >
          <pp-dashlet
            [ppCanEdit]="canEdit"
            [ppDashlet]="dashlet"
            [ppAssetId]="ppAsset.id"
            [ppDefaultWorkspaces]="defaultWorkspaces"
            (ppUpdateUserDashlets)="updateUserDashlets()"
          ></pp-dashlet>
        </gridster-item>
      }
    </gridster>
  }

  @if (dashlets.length === 0) {
    <div class="dashboard__content dashboard__empty">
      <div class="dashboard__emptyMessage">
        <p class="dashboard__emptyMessageText">
          {{ 'empty_asset_dashboard_message' | ppTranslate }}
        </p>
        @if (canEdit) {
          <pp-button ppStyle="secondary" (click)="addDashlet()">
            <div class="dashboard__emptyMessageButton">
              {{ 'add_dashlet' | ppTranslate }}
              <pp-icon
                [ppSrc]="EIconPath.ICON_NAV_PLUS_14"
                ppClass="setSize14"
                ppColor="inherit"
              ></pp-icon>
            </div>
          </pp-button>
        }
      </div>
    </div>
  }
  </div>
</div>
